import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";

export default function ScrollToError() {
	const formik = useFormikContext();
	const submitting = formik?.isSubmitting;
	const prevSubmitting = useRef(submitting);

	useEffect(() => {
		// Only scroll when transitioning from submitting (true) to not submitting (false)
		if (prevSubmitting.current && !submitting) {
			const el = document.querySelector(".Mui-error, [data-error]");
			(el?.parentElement ?? el)?.scrollIntoView({ behavior: "smooth", block: "center" });
		}
		prevSubmitting.current = submitting;
	}, [submitting]);

	return null;
}
